import * as SettingActions from './setting.actions';
import {SubscriptionModel} from '../subscription.model';
import {SubscriptionItemModel} from '../subscription-item.model';

export interface State {
  subscriptions: SubscriptionModel[];
  subscription: SubscriptionModel;
  subscriptionItems: SubscriptionItemModel[];
}

export const initState: State = {
  subscriptions: [],
  subscription: null,
  subscriptionItems: []
};

export function settingReducer(state: State = initState, action: SettingActions.SettingActions) {
  switch (action.type) {
    case SettingActions.SAVE_SUBSCRIPTIONS:
      return {
        ...state,
        subscriptions: action.payload
      };
    case SettingActions.SAVE_SUBSCRIPTION:
      return {
        ...state,
        subscription: action.payload
      };
    case SettingActions.SAVE_SUBSCRIPTION_ITEMS:
      return {
        ...state,
        subscriptionItems: action.payload
      };
    case SettingActions.UPDATE_LOCAL_SUBSCRIPTION:
      for (let i in state.subscriptions) {
        console.log(i);
        if (state.subscriptions[i].id === action.payload.id) {
          state.subscriptions[i][action.payload.keyName] = action.payload.value;
        }
      }
      return {
        ...state
      };
  }
  return state;
}
